import { LabCanvas3D } from './LabCanvas3D';
import { type ConservationSceneState, createConservationScene } from './conservationScene';

/** Real-world view of the conservation Explore: a conical flask on a top-pan balance, driven by the worked result. */
export function Conservation3D({ state, playing, label }: { state: ConservationSceneState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createConservationScene} state={state} playing={playing} label={label} hint="Drag to turn the flask" />;
}
